import { render } from "./ListiniDetail.vue?vue&type=template&id=bf938dc2"
import script from "./ListiniDetail.vue?vue&type=script&lang=js"
export * from "./ListiniDetail.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__